import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { whatsappTemplatesQuery } from "../../../lib/templates/whatsapp/whatsappTemplatesQuery"

export function useRefreshWhatsappTemplatesMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async () => {
      const response = await axios.post("/integrations/whatsapp/refresh-templates")

      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: whatsappTemplatesQuery().queryKey })
    },
  })
}
